module.exports = __webpack_public_path__ + "img/part-2-title.06c0a849.png";